module.exports = __webpack_public_path__ + "static/imgs/collectingMaterials.848bc82.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/collectingMaterials.jpg
// module id = WAPU
// module chunks = 1